import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.timers.js";
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective } from "vue";
var _hoisted_1 = {
  key: 0,
  "class": "swiperwrap"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  "class": "swiperbg"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = ["src"];
var _hoisted_6 = ["innerHTML"];
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  key: 0,
  href: "item.url"
};
var _hoisted_9 = ["src"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = ["src"];
var _hoisted_12 = ["innerHTML"];
var _hoisted_13 = {
  key: 0,
  "class": "ffswiperpoint"
};
var _hoisted_14 = ["onClick"];
export default {
  __name: 'ffswiper',
  props: {
    imgs: {
      type: String,
      "default": ''
    },
    infoList: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    options: {
      type: Object,
      "default": function _default() {}
    },
    indexCur: {
      type: Number,
      "default": 0
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var _getCurrentInstance = getCurrentInstance(),
      proxy = _getCurrentInstance.proxy;

    //const emit = defineEmits(['update:indexCur', 'update:direct'])

    var LBInterval;
    var optionsDefault = {
      'isautoplay': true,
      'isstop': false,
      'duration': 3000,
      'ispoint': true,
      'isfull': false,
      'istrandriect': false
    }; //isfull是内容格式时是否有padding

    var FFdata = reactive({
      direct: 1,
      myIndex: 0,
      //组件内索引
      myStop: false //组件内停止
    });
    var FFprops = __props;
    var Coptions = computed(function () {
      return Object.assign({}, optionsDefault, FFprops.options);
    });
    var Cimgs = computed(function () {
      return FFprops.imgs ? FFprops.imgs.split(',') : [];
    });
    var CisImg = computed(function () {
      return Cimgs.value.length > 0;
    });
    var CitemMax = computed(function () {
      return CisImg.value ? Cimgs.value.length : FFprops.infoList.length;
    });
    var CtranName = computed(function () {
      return FFdata.direct == 1 ? 'ffswiperleft' : 'ffswiperright';
    });
    var CisStop = computed(function () {
      return FFdata.myStop || Coptions.value.isstop;
    });
    var updateIndexCur = function updateIndexCur(v, direct) {
      if (CitemMax.value > 1) {
        FFdata.myIndex = v >= CitemMax.value ? 0 : v < 0 ? CitemMax.value - 1 : v;
        if (Coptions.value.istrandriect && direct && direct != FFprops.direct) {
          FFdata.direct = direct;
        }
      }
    };
    var autoPlay = function autoPlay() {
      if (Coptions.value.isautoplay) {
        LBInterval = window.setInterval(function () {
          if (!CisStop.value) {
            FFdata.direct == 1 ? swiperNext() : swiperPrev();
          }
        }, Coptions.value.duration);
      }
    };
    var touchSwiper = function touchSwiper(e) {
      if (e.direction == "Left") {
        swiperNext();
      } else if (e.direction == "Right") {
        swiperPrev();
      }
    };
    var swiperGo = function swiperGo(v) {
      var direct = v > FFdata.myIndex ? 1 : 2;
      updateIndexCur(v, direct);
    };
    var swiperPrev = function swiperPrev() {
      var v = FFdata.myIndex - 1;
      swiperGo(v);
    };
    var swiperNext = function swiperNext() {
      var v = FFdata.myIndex + 1;
      swiperGo(v);
    };
    var swiperOver = function swiperOver() {
      FFdata.myStop = true;
    };
    var swiperOut = function swiperOut() {
      FFdata.myStop = false;
    };
    onMounted(function () {
      FFdata.myIndex = FFprops.indexCur;
      autoPlay();
    });
    onUnmounted(function () {
      window.clearInterval(LBInterval);
    });
    __expose({
      swiperPrev: swiperPrev,
      swiperNext: swiperNext,
      swiperGo: swiperGo
    });
    return function (_ctx, _cache) {
      var _directive_finger = _resolveDirective("finger");
      return _unref(CitemMax) == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        src: FFprops.imgs,
        "class": "ffbannerimg"
      }, null, 8, _hoisted_2)])) : _unref(CitemMax) ? _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": "swiperwrap",
        onMouseover: swiperOver,
        onMouseout: swiperOut
      }, [_createElementVNode("ul", _hoisted_3, [_unref(CisImg) ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(_unref(Cimgs), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [_createElementVNode("img", {
          src: item,
          "class": "swiperimg"
        }, null, 8, _hoisted_4)]);
      }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(__props.infoList, function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          key: index
        }, [item.img ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: item.img,
          "class": "swiperimg"
        }, null, 8, _hoisted_5)) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          "class": _normalizeClass([_unref(Coptions).isfull ? 'editor2' : 'editor'])
        }, [_createElementVNode("span", {
          innerHTML: _ctx.$common.langinfo(item.content, item.content_en)
        }, null, 8, _hoisted_6)], 2))]);
      }), 128))]), _createVNode(_TransitionGroup, {
        name: _unref(CtranName),
        tag: "ul",
        "class": "swiperbox"
      }, {
        "default": _withCtx(function () {
          return [_unref(CisImg) ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(_unref(Cimgs), function (item, index) {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              key: index
            }, [_createElementVNode("img", {
              src: item,
              "class": "swiperimg"
            }, null, 8, _hoisted_7)])), [[_vShow, index == _unref(FFdata).myIndex]]);
          }), 128)) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(__props.infoList, function (item, index) {
            return _withDirectives((_openBlock(), _createElementBlock("li", {
              key: index
            }, [item.url ? (_openBlock(), _createElementBlock("a", _hoisted_8, [item.img ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.img,
              "class": "swiperimg"
            }, null, 8, _hoisted_9)) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              "class": _normalizeClass([_unref(Coptions).isfull ? 'editor2' : 'editor'])
            }, [_createElementVNode("span", {
              innerHTML: _ctx.$common.langinfo(item.content, item.content_en)
            }, null, 8, _hoisted_10)], 2))])) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [item.img ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.img,
              "class": "swiperimg"
            }, null, 8, _hoisted_11)) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              "class": _normalizeClass([_unref(Coptions).isfull ? 'editor2' : 'editor'])
            }, [_createElementVNode("span", {
              innerHTML: _ctx.$common.langinfo(item.content, item.content_en)
            }, null, 8, _hoisted_12)], 2))], 64))])), [[_vShow, index == _unref(FFdata).myIndex]]);
          }), 128))];
        }),
        _: 1
      }, 8, ["name"]), _unref(Coptions).ispoint && _unref(CitemMax) > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CitemMax), function (index) {
        return _openBlock(), _createElementBlock("a", {
          key: index,
          href: "#",
          onClick: function onClick($event) {
            return swiperGo(index - 1);
          },
          "class": _normalizeClass({
            cs: index == _unref(FFdata).myIndex + 1
          })
        }, null, 10, _hoisted_14);
      }), 128))])) : _createCommentVNode("", true)], 32)), [[_directive_finger, touchSwiper, "swipe"]]) : _createCommentVNode("", true);
    };
  }
};